module.exports = __webpack_public_path__ + "static/portfolio-8-88177b425273867c0327834608847754.jpg";